import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

const STAT_CARDS = [
  { key: 'total', label: 'Total Tickets', color: '#7c3aed', icon: '🎫' },
  { key: 'open', label: 'Open', color: '#2563eb', icon: '📬' },
  { key: 'resolved', label: 'Resolved / Closed', color: '#059669', icon: '✅' },
  { key: 'overdue', label: 'Overdue (SLA)', color: '#dc2626', icon: '🚨' },
];

export default function Dashboard() {
  const [stats, setStats] = useState({});
  const [recent, setRecent] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const [s, t] = await Promise.all([
          api.get('/tickets/stats'),
          api.get('/tickets'),
        ]);
        setStats(s.data);
        setRecent(t.data.slice(0, 5));
      } catch (e) {
        // interceptor handles auth errors
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div>
      <h1 style={{ fontSize: 24, fontWeight: 700, color: '#0f172a', marginBottom: 4 }}>Dashboard</h1>
      <p style={{ color: '#64748b', marginBottom: 24 }}>Support ticket overview</p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 16, marginBottom: 28 }}>
        {STAT_CARDS.map(c => (
          <div key={c.key} className="card" style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <div style={{ fontSize: 28 }}>{c.icon}</div>
            <div>
              <div style={{ fontSize: 28, fontWeight: 700, color: c.color }}>{loading ? '—' : (stats[c.key] ?? 0)}</div>
              <div style={{ fontSize: 13, color: '#64748b' }}>{c.label}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <h2 style={{ fontSize: 16, fontWeight: 600 }}>Recent Tickets</h2>
          <Link to="/tickets" style={{ fontSize: 13, fontWeight: 500 }}>View all →</Link>
        </div>
        {recent.length === 0 ? (
          <div style={{ color: '#94a3b8', padding: '20px 0', textAlign: 'center' }}>
            {loading ? 'Loading...' : 'No tickets yet.'}
          </div>
        ) : (
          <table>
            <thead>
              <tr><th>Ticket</th><th>Subject</th><th>Priority</th><th>Status</th></tr>
            </thead>
            <tbody>
              {recent.map(t => (
                <tr key={t.id}>
                  <td style={{ fontWeight: 600 }}>{t.ticketNumber || `#${t.id}`}</td>
                  <td>{t.subject}</td>
                  <td>{t.priority}</td>
                  <td>{t.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
